/**
 * Legacy class replaced by translations. Please don't add anything here, translate all copy instead
 */
export default {
    INVOICE_UNPAID: 'Obetald faktura',
    INVOICE_UNPAID_DESCRIPTION: 'Du har väntande faktura(or)',
    INVOICE_OVERDUE: 'Förfallen faktura',
    INVOICE_OVERDUE_DESCRIPTION:
        'Du har en eller flera förfallna fakturor (registrering av nya inbetalningar är fördröjd).',
    BANK_ACCOUNT_MISSING: 'Kontouppgifter',
    BANK_ACCOUNT_MISSING_DESCRIPTION:
        'Fyll i dina kontouppgifter för att få betalt när du säljer.',
    PAYOUT_FAILED: 'Misslyckad utbetalning',
    PAYOUT_FAILED_DESCRIPTION: 'En utbetalning har misslyckats.',
    PAYMENT_READY_BANK_ACCOUNT_MISSING: 'Misslyckad utbetalning',
    PAYMENT_READY_BANK_ACCOUNT_MISSING_DESCRIPTION:
        'Du har en väntande utbetalning. Fyll i dina kontouppgifter för att få pengarna.',
    SWISH_MISSING: 'Swish saknas',
    SWISH_MISSING_DESCRIPTION:
        'De flesta köpare väljer att betala med Swish. Fyll i ditt Swish-nummer för att inte missa betalningar.',
    ADD_SWISH: 'Lägg till Swish',
    NO_THANKS_SWISH: 'Nej tack till Swish',
    I_UNDERSTAND: 'Jag förstår',
    IFRAME_NOT_SUPPORTED: 'Din browser saknar stöd för iframes',
    COOKIES: {
        HEADER: 'Information om cookies',
        DESC:
            'Tradera använder cookies (kakor) för att ge dig en bättre upplevelse.',
        READ_MORE: 'Läs mer om vårt användande av cookies.'
    },
    WELCOME_TO_TRADERA: 'Välkommen till Sveriges största marknadsplats!',
    GET_STARTED_BUYING: 'Kom igång med att handla på Tradera',
    GET_STARTED_SELLING: 'Kom igång med att sälja på Tradera',
    VIEW_MORE_VIDEOS: 'Se fler videos',
    MY_TRADERA: {
        MESSAGING_OPT_IN:
            'Skicka och ta emot meddelanden från köpare/säljare via Tradera.',
        MESSAGING_OPT_IN_INFO: '(Valbart som butik eller företagssäljare)',
        MESSAGING_EMAIL_SETTING: 'E-postkopia på lästa meddelanden'
    },
    DISCOVER: {
        FILTERS: {
            ALL_CATEGORIES: 'Alla kategorier',
            BRANDS: 'Varumärken',
            CONDITION: 'Skick',
            ITEM_TYPE: 'Annonsformat',
            PRICE: 'Pris',
            SELLER_TYPE: 'Typ av säljare',
            COUNTY: 'Område',
            ITEM_STATUS: 'Status',
            SORTING: 'Sortering',
            CLEAR: 'Återställ'
        }
    },
    META: {
        DEFAULT_SITE_NAME: 'Tradera',
        DEFAULT_DESCRIPTION:
            'Köp och sälj bland auktioner och till fast pris på Tradera.com. Fynda bland massor av auktioner.'
    }
};
